import { UploadFile } from "antd";
import { RcFile } from "antd/es/upload";
import { ClipboardEvent } from "react";
import { v4 as uuidv4 } from 'uuid';
import ImageUploaderStore from "../../stores/common/image-uploader";

const handleKeybordPhotoPaste = (event: ClipboardEvent<HTMLDivElement>, photoUploaderStore: ImageUploaderStore, 
    solutionUploaderStore: ImageUploaderStore, 
    callback?: () => any) => {

    if (event.clipboardData.files.length) {
        
        const ff = event.clipboardData.files[0];
        const file: UploadFile = {
            name: ff.name,
            size: ff.size,
            type: ff.type,
            uid: uuidv4(),
            originFileObj: ff as RcFile
        };

        photoUploaderStore.handleManualUpload(file, callback);
        solutionUploaderStore.handleManualUpload(file);
    }
};

export default handleKeybordPhotoPaste;